export default "__VITE_ASSET__87acad85__"